
import {useState, useCallback} from 'react';
import {Button, Card, Divider, Popover, Row, Col} from 'antd';
import {BuyerSelectWidget} from "./BuyerSelectWidget";
import {TotalsCard} from "./TotalsCard";
import {CompleteInvoiceWidget} from "./CompleteInvoiceWidget";
import {addInventoryToCart, clearCart, createInvoice} from "../../api/Api";
import {toMs} from "../../util/timeutils";
import {InventoryTable} from "../inventory/InventoryTable";
import {useTimer} from "./useTimer";
import {SalesInvoiceTable} from "./SalesInvoiceTable";
import {InventorySearchWidget} from "./InventorySearchWidget";
import {displayToFixedUnit} from "../../util/unitutils";

export const NewInvoice = ({refresh, onRefresh, onApiFail, props}) => {
    const [invoiceItems, setInvoiceItems] = useState({});
    const [selectedBuyer, setSelectedBuyer] = useState(null);
    const [value, setValue] = useState("");
    const [isInventoryOpen, setIsInventoryOpen] = useState(false);

    const onComplete = async () => {
        console.log('invoice complete');
        const buyerId = selectedBuyer.id

        // clear the page state immediately to avoid double completions
        setSelectedBuyer(null);
        setValue("");
        setInvoiceItems({});

        createInvoice(buyerId, invoiceItems).then(r => {
            // successfully created invoice
            console.log(`successfully created invoice`);

            // notify the rest of the ui
            if (onRefresh) {
                onRefresh();
            }

            // stop the timer and interval
            setCartExpire(null);

        }).catch (e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }

    const onBuyerSelect = (val) => {
        setSelectedBuyer(val);
    }

    const onOpenInventory = () => {
        setIsInventoryOpen(true);
    }

    const onCloseInventory = () => {
        setIsInventoryOpen(false);
    }

    const [cartExpire, setCartExpire] = useState(null);
    const onTimerComplete = useCallback(() => {
        // clear the cart
        setInvoiceItems({})
        try {
            console.log(`clearing the cart..`);
            clearCart(false);
        } catch (e) {
        }
    }, []);
    const cartTimeToLive = useTimer({expire: cartExpire, onComplete: onTimerComplete});

    const maxCartTime = "15 minutes";
    const addToCart = (itemRecord, quantity) => {
        // quantity needs to arrive as fixed unit
        console.log(`adding this ${JSON.stringify(itemRecord)}`)
        // if this is the first item being added to the invoice start the timer
        if (Object.keys(invoiceItems).length === 0) {
            const now = new Date();
            setCartExpire(now.valueOf() + toMs(maxCartTime));
        }

        let nextInvoiceItems = {
            ...invoiceItems
        }

        const key = itemRecord.id;
        if (nextInvoiceItems[key] !== undefined) {
            // we're adding more of an item that's already in the cart
            nextInvoiceItems[key].quantity += quantity;
        } else {
            // it's an new item
            nextInvoiceItems[key] = {
                quantity,
                item: {
                    ...itemRecord,
                    discount: 0,
                    lineDiscount: 0,
                }
            };
        }

        setInvoiceItems (nextInvoiceItems);
    }

    const addCartForWidget = (itemRecord, quantity) => {
        const fixedQuantity = displayToFixedUnit(quantity, itemRecord.unit);
        addInventoryToCart(itemRecord.id, fixedQuantity).then(r => {
            if (addToCart) {
                addToCart(itemRecord, fixedQuantity)
            }
            if (onRefresh) onRefresh();
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
            if (onRefresh) onRefresh();
        })
    }

    const deleteCart = async () => {
        // stop the timer and interval
        setCartExpire(null);
        // clear the inventory form
        setSelectedBuyer(null);
        setInvoiceItems({});
        if (onRefresh) {
            onRefresh()};
        try {
            await clearCart(true).then(r => {
                if (onRefresh) onRefresh()
            });
        } catch (e) {
        }
    }

    const extendTime = () => {
        const now = new Date();
        setCartExpire(now.valueOf() + toMs(maxCartTime));
    }

    const expireContent = (cartTimeToLive > 0) && <Col span={6}><div style={{paddingTop: '5px', color: 'red'}}>Items expire in {cartTimeToLive} Seconds</div></Col>
    const deleteContent = (cartTimeToLive > 0) && <Col span={4}><Button onClick={deleteCart}>Delete Invoice</Button></Col>
    const extendContent = (cartTimeToLive > 0) && <Col span={4}><Button onClick={extendTime}>More Time</Button></Col>
    const invoiceView = <div style={{textAlign: 'left'}}>
        <BuyerSelectWidget selectedBuyer={selectedBuyer} onSelect={onBuyerSelect} value={value} setValue={setValue} onApiFail={onApiFail} />
        <p/>
        <Card title={'Items'}>
            <SalesInvoiceTable invoiceItems={invoiceItems} updateItems={setInvoiceItems} />
            <Divider />
            <InventorySearchWidget onApiFail={onApiFail} refresh={refresh} onSelect={addCartForWidget}/>
            <Row style={{marginTop: "5px", marginBottom: "5px"}}>
                <Col span={6}>
                    <Popover content={`You couldn't find it,  search inventory instead`}>
                    <Button onClick={onOpenInventory}>Search Inventory</Button>
                    </Popover>
                </Col>
            </Row>
        <p/>
        </Card>
        <TotalsCard invoiceItems={invoiceItems} />
        <Row  style={{paddingTop: '5px', paddingBottom: '5px'}}>
            <Col span={2}><CompleteInvoiceWidget buyer={selectedBuyer} invoiceItems={invoiceItems} onClick={onComplete} /></Col>
            {expireContent}
            {deleteContent}
            {extendContent}
        </Row>
    </div>

    const inventoryView = <div>
        <Row><Button onClick={onCloseInventory}>Back</Button></Row>
        <InventoryTable refresh={refresh} onApiFail={onApiFail} addToCart={addToCart} disableLinks={true}/>
        <Row><Button onClick={onCloseInventory}>Back</Button></Row>
    </div>


    return (isInventoryOpen) ? inventoryView : invoiceView;
}